<!--  示例：简易字典
  <simple-dict dict-type="userType" v-model="userType" ></simple-dict>
 -->
<template>
  <el-select :filterable="filterable" class="simpleDict" @change="changeSelect" v-model="selectValue" :disabled="noSelect" :placeholder="tipsValue" ref="simpleDict">
    <el-option v-if="showAll" key="" label="全部" value=""></el-option>
    <template v-for="item in options">
      <el-option v-if="!(showAll&&item.value=='')"
                 :key="item.value"
                 :label="item.label"
                 :value="item.value"
                 :disabled="copyDisableArr.indexOf(parseInt(item.value)) !== -1"></el-option>
    </template>
  </el-select>
</template>

<script>
  export default {
    name: 'simple-dict',
    //disableArr禁用数组 注：仅用于数字
    props: ['dictType', 'modelValue', 'disabled','isAll',"tipsValue","disableArr",'initOptions','filterable','type'],
    data () {
      return {
        noSelect: '',
        selectValue:'',
        showAll:'',
        copyDisableArr:[],
        classifyList:null,
      };
    },
    computed:{
      options(){
        if(this.initOptions){
          return this.initOptions;
        }
        if(this.classifyList!=null){
          return this.classifyList;
        }
        const options = this.$store.state.dictMap[this.dictType];
        /*    if(options&&options[0].value!=''&&options[0].label!=this.tipsValue){
              options.unshift({label:this.tipsValue!=null?this.tipsValue:"请选择",value:'0'})
            }*/
        return options;
      }
    },
    watch: {
      modelValue: function (newValue, oldValue) {
        this.selectValue = newValue+"";
      }
    },
    methods: {
      changeSelect: function (value) {
        this.$emit('update:modelValue', value);
      },
      focus:function(){
        this.$refs['simpleDict'].focus();
      }
    },
    mounted () {
      this.selectValue = $.isNotEmpty(this.modelValue)?this.modelValue+"":this.modelValue;
      this.noSelect = (this.disabled == '' || this.disabled == 'true');
      this.showAll = (this.isAll == '' || this.isAll == 'true');
      if (!$.isEmptyObject(this.disableArr)) {
        this.copyDisableArr = this.disableArr;
      }
      if(this.dictType=='brand'){
        this.simplePost("/api/mgr/business/brand/getAll", {type:this.type},res=>{
          if(res.data){
            this.classifyList =  res.data.map(item=>{
              return {label:item.name,value:item.id};
            })
          }else{
            this.classifyList =[];
          }

        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .classify{
    line-height: 0;
  }
</style>
